import { gsap } from 'gsap';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

const scrollTriggerElem = document.querySelector('.block-simplify-shapes .scroll-wrapper');
if (scrollTriggerElem) {
	let scrollTriggerConfig = {};
	let timeScale = 0.75;
	const mm = gsap.matchMedia();

	mm.add('(min-width: 992px)', () => {
		scrollTriggerConfig = {
			scrollTrigger: {
				trigger: '.block-simplify-shapes .scroll-wrapper',
				// pin to top of header
				start: '-80px',
				// extends 5 viewport heights
				end: '+=500%',
				scrub: 1,
				pin: true,
			},
		};
		const tl = gsap.timeline(scrollTriggerConfig);
		tl.timeScale(timeScale);
		tl.to('body', { delay: 1 }, 'spacer');

		tl.to('.scroll-shapes .shape-1', { duration: 10, x: 323, y: 126 }, 'combine');
		tl.to('.scroll-shapes .shape-2', { duration: 10, x: -52, y: 240 }, 'combine');
		tl.to('.scroll-shapes .shape-3', { duration: 10, x: -629, y: 22, scale: 2.6 }, 'combine');
		tl.to(
			'.scroll-shapes .shape-4',
			{ duration: 10, x: 254, y: -232, rotate: 59.54, transformOrigin: 'center bottom' },
			'combine'
		);
		tl.to('.scroll-shapes .shape-5', { duration: 10, x: -303, y: -104 }, 'combine');
		tl.to('.scroll-shapes .icon-1', { duration: 10, opacity: 0 }, 'combine');
		tl.to('.scroll-shapes .icon-2', { duration: 10, opacity: 0 }, 'combine');
		tl.to(
			'.scroll-shapes .icon-3',
			{ duration: 10, x: 30, y: 30, scale: 0.3846153846, opacity: 0 },
			'combine'
		);
		tl.to('.scroll-shapes .icon-4', { duration: 10, opacity: 0 }, 'combine');
		tl.to('.scroll-shapes .icon-5', { duration: 10, opacity: 0 }, 'combine');
		tl.to('.content-1', { opacity: 0, y: -100, duration: 5, pointerEvents: 'none' }, '>-7.5');
		tl.to('.scroll-shapes .color-shapes', { duration: 4, opacity: 0, rotate: 30 }, 'shift');
		tl.from('.scroll-shapes__logo', { duration: 4, rotate: -30, opacity: 0 }, 'shift');
		tl.from('.scroll-shapes__logo-circle', { duration: 4, opacity: 0 }, 'shift');
		tl.to('.scroll-shapes__logo-circle', { duration: 20, scale: 5 }, 'circle_grow');
		tl.to('.scroll-shapes__logo', { duration: 20, opacity: 0, y: -100 }, 'circle_grow');
		tl.fromTo(
			'.content-2',
			{ opacity: 0, y: 300, duration: 8, pointerEvents: 'none' },
			{ opacity: 1, y: 0, duration: 8, pointerEvents: 'all' },
			'content-=1'
		);
		tl.fromTo(
			'.content-2 p',
			{ duration: 8, opacity: 0, y: -50 },
			{ duration: 8, opacity: 1, y: 0 },
			'content-1'
		);
		tl.to('.dotted-lines', { duration: 3, '--dottedReveal': 0 }, 'content-2');
		tl.fromTo(
			'.icon-cards',
			{ duration: 8, opacity: 0 },
			{ duration: 8, opacity: 1 },
			'content-3'
		);
		tl.add('combine', '-=0.5');

		// scroll to end of scrolltrigger if icon card is focused
		document.querySelectorAll('.icon-card').forEach((iconCard) => {
			iconCard.addEventListener('focus', () => {
				if (!window.reduceAnimations) {
					gsap.to(window, {
						scrollTo: tl.scrollTrigger.labelToScroll('combine'),
						duration: 0,
					});
				}
			});
		});

		if (window.reduceAnimations) {
			disableSimplifyShapes(tl);
		}
		document.addEventListener('prefers-reduced-motion', (event) => {
			if (event.detail.reduceAnimations) {
				disableSimplifyShapes(tl);
			} else {
				tl.scrollTrigger.enable();
			}
		});
	});

	mm.add('(max-width: 991px)', () => {
		scrollTriggerConfig = {
			scrollTrigger: {
				trigger: '.block-simplify-shapes .scroll-shapes-mobile-animated',
				start: 'bottom 75%',
			},
		};
		timeScale = 8;
		const tl = gsap.timeline(scrollTriggerConfig);
		tl.timeScale(timeScale);
		tl.to(
			'.scroll-shapes-mobile .shape-1',
			{ duration: 10, x: -15.58, scale: 1.2566 },
			'combine'
		);
		tl.to(
			'.scroll-shapes-mobile .shape-2',
			{ duration: 10, x: -49.38, y: 46.36, scale: 1.2218 },
			'combine'
		);
		tl.to(
			'.scroll-shapes-mobile .shape-3',
			{ duration: 10, x: -95, y: -95, scale: 3.3182871782 },
			'combine'
		);
		tl.to(
			'.scroll-shapes-mobile .shape-4',
			{
				duration: 10,
				x: -23,
				y: -83,
				rotate: 59.54,
				scale: 1.2573481385,
				transformOrigin: 'center bottom',
			},
			'combine'
		);
		tl.to(
			'.scroll-shapes-mobile .shape-5',
			{ duration: 10, x: -37.43, y: -33.88, scale: 1.3204466548 },
			'combine'
		);
		tl.to('.scroll-shapes-mobile .icon-1', { duration: 10, opacity: 0 }, 'combine');
		tl.to('.scroll-shapes-mobile .icon-2', { duration: 10, opacity: 0 }, 'combine');
		tl.to(
			'.scroll-shapes-mobile .icon-3',
			{ duration: 10, x: 30, y: 30, scale: 0.3846153846, opacity: 0 },
			'combine'
		);
		tl.to('.scroll-shapes-mobile .icon-4', { duration: 10, opacity: 0 }, 'combine');
		tl.to('.scroll-shapes-mobile .icon-5', { duration: 10, opacity: 0 }, 'combine');
		tl.to(
			'.scroll-shapes-mobile .color-shapes',
			{ duration: 4, opacity: 0, rotate: 30 },
			'shift'
		);
		tl.from('.scroll-shapes-mobile__logo', { duration: 4, rotate: -30, opacity: 0 }, 'shift');
		tl.from('.scroll-shapes-mobile__logo-circle', { duration: 4, opacity: 0 }, 'shift');
		if (window.reduceAnimations) {
			tl.progress(1);
			disableSimplifyShapes(tl);
		}
		document.addEventListener('prefers-reduced-motion', (event) => {
			if (event.detail.reduceAnimations) {
				tl.progress(1);
				disableSimplifyShapes(tl);
			} else {
				tl.scrollTrigger.enable();
			}
		});
	});
}

function disableSimplifyShapes(timeline) {
	gsap.set('.content-1', { clearProps: true });
	gsap.set('.content-2', { clearProps: true });
	gsap.set('.content-2 p', { clearProps: true });
	gsap.set('.icon-cards', { clearProps: true });
	timeline.scrollTrigger.disable();
}
